export const SERVERLESS_ENV_CONTEXT_KEY = Symbol.for("voltagent.serverless.env");
